import { environment } from 'src/environments/environment'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { Observable } from 'rxjs'
import { WholeNumberValidator } from 'src/app/shared/validators/whole-number.validator'
import { Member } from 'src/app/features/member/member'

@Component({
  selector: 'registration-category-options-card',
  templateUrl: './registration-category-options-card.component.html',
  styleUrls: ['./registration-category-options-card.component.scss']
})
export class RegistrationCategoryOptionsCardComponent implements OnInit {
  @Input() formValues: any
  @Output() onSubmit = new EventEmitter<any>()
  public isCollapsedRegCategoryOptions = true
  public form: UntypedFormGroup
  public options$: Observable<any[]>
  public lastOptionId: number = 0
  public accessRights = AccessRights
  public member$: Observable<Member>

  public hasExtendedCategories: boolean =
    environment.moduleConfigs.hasExtendedCategories
  public availableLanguages = environment.frontendLanguages.reduce(
    (acc, curr) => {
      if (curr != 'xx') return (acc[curr] = true), acc
      else return acc
    },
    {}
  )

  constructor(private fb: UntypedFormBuilder) {}

  get regCategoryOptionOptionsFormArray() {
    return this.form?.controls?.options as UntypedFormArray
  }

  ngOnInit() {
    this.form = this.fb.group({
      description_nl: [null, []],
      description_en: [null, []],
      description_fr: [null, []],
      description_de: [null, []],
      options: this.fb.array([])
    })

    if (this.formValues) {
      const optionSets = this.formValues.options

      optionSets.map(() =>
        this.regCategoryOptionOptionsFormArray?.length < optionSets?.length
          ? this.addRegCatOptionOptionRow()
          : null
      )

      this.form?.patchValue(this.formValues)
    }
  }

  public getRegCatOptionOptionsRow() {
    if (this.formValues?.options?.length) {
      if (this.lastOptionId == 0) {
        this.lastOptionId = this.formValues.options[0]?.optionId + 1
      } else {
        //this.lastOptionId += 1
        const sorted = this.form.controls?.options?.value?.sort((a, b) =>
          a.optionId < b.optionId ? -1 : 1
        )
        this.lastOptionId =
          sorted[this.form.controls?.options?.value?.length - 1]?.optionId + 1
      }

      return this.fb.group({
        name_en: ['', []],
        name_nl: ['', []],
        name_fr: ['', []],
        name_de: ['', []],
        optionId: [
          this.lastOptionId,
          [WholeNumberValidator(), Validators.min(1)]
        ],
        categoryValue: [null, [Validators.required]],
        group: ['', []]
      })
    }

    this.lastOptionId += 1

    return this.fb.group({
      name_en: ['', []],
      name_nl: ['', []],
      name_fr: ['', []],
      name_de: ['', []],
      optionId: [
        this.lastOptionId,
        [WholeNumberValidator(), Validators.min(1)]
      ],
      categoryValue: [null, [Validators.required]],
      group: ['', []]
    })
  }

  public addRegCatOptionOptionRow() {
    this.regCategoryOptionOptionsFormArray.push(
      this.getRegCatOptionOptionsRow()
    )
  }

  public deleteRegCatOptionOptionRow(index): void {
    if (this.lastOptionId == 1) {
      this.lastOptionId = 0
    } else if (this.lastOptionId) {
      this.lastOptionId -= 1
    }
    this.regCategoryOptionOptionsFormArray.removeAt(index)
  }

  public onSubmitRegistrationCategoryFilter() {
    if (this.form.invalid) {
      this.markDirty()
      return
    }

    this.onSubmit.emit({
      key: 'registration_category_options',
      valueToSave: JSON.stringify(this.form.value, null, 4)
    })
  }

  markDirty() {
    this.markGroupDirty(this.form)
  }

  markGroupDirty(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      switch (formGroup.get(key).constructor.name) {
        case 'FormGroup':
          this.markGroupDirty(formGroup.get(key) as UntypedFormGroup)
          break
        case 'FormArray':
          this.markArrayDirty(formGroup.get(key) as UntypedFormArray)
          break
        case 'FormControl':
          this.markControlDirty(formGroup.get(key) as UntypedFormControl)
          break
      }
    })
  }
  markArrayDirty(formArray: UntypedFormArray) {
    formArray.controls.forEach((control) => {
      switch (control.constructor.name) {
        case 'FormGroup':
          this.markGroupDirty(control as UntypedFormGroup)
          break
        case 'FormArray':
          this.markArrayDirty(control as UntypedFormArray)
          break
        case 'FormControl':
          this.markControlDirty(control as UntypedFormControl)
          break
      }
    })
  }
  markControlDirty(formControl: UntypedFormControl) {
    formControl.markAsDirty()
  }
}
